/**
 * ЭТАП 2 — SSR-shim для fslightbox-react (страница товара: медиа-галерея,
 * BestComment; рецепты, комментарии).
 *
 * Пакет — CJS c __esModule:true и default-экспортом (компонент), БЕЗ ESM
 * `module`-поля. Под dev-SSR внешний Node-интероп отдаёт объект exports
 * вместо компонента → <FsLightbox/> === object ("Element type is invalid:
 * got object"). noExternal ему противопоказан (чистый CJS — "module is not
 * defined", см. комментарий к ssr.noExternal).
 *
 * Как и в reactScrollUp: распутываем цепочку `.default` до первой function.
 * alias `^fslightbox-react$` → этот файл (см. vite.start.config.mts);
 * импорт полного пути index.js внутри шима алиасом не матчится.
 */
// @ts-ignore -- у пакета нет типов на подпуть index.js
import * as ns from 'fslightbox-react/index.js';
import type FsLightboxT from 'fslightbox-react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let Comp: any = ns;
for (let i = 0; i < 4 && Comp && typeof Comp !== 'function'; i++) {
  Comp = Comp.default;
}

export default Comp as typeof FsLightboxT;
